/** @format */

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams, useHistory, useLocation } from 'react-router-dom';
import Loader from 'src/components/Loader';
import LoadingScreen from 'src/components/LoadingScreen';
import Page from 'src/components/Page';
import { TICKET_MODAL, TICKET_STATUS } from 'src/constants';
import { getCompanyTicketDetail, getTicketDetail } from 'src/slices/tickets';
import { useDispatch, useSelector } from 'src/store';
import { format, formatDistance } from 'date-fns';
import UpdateTicketModal from 'src/components/widget/tickets/updateTicketModal';
import { Comment, ProgressBar, TicketInfo } from 'src/components/ticket';

export default function TicketDetail() {
  const history = useHistory();
  const { t } = useTranslation();
  let { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { ticketDetail } = useSelector(state => state.tickets);
  const [modalOpened, setModalOpened] = React.useState(null);

  React.useEffect(() => {
    const Storage = window.localStorage;
    const lang = Storage.i18nextLng || 'en';
    // if (location.pathname.includes('company')) dispatch(getCompanyTicketDetail(lang, id));
    // else dispatch(getTicketDetail(lang, id));
    dispatch(getTicketDetail(lang, id));
  }, []);

  const toggleUpdateTicketModal = incidentid => {
    if (modalOpened === TICKET_MODAL.UPDATE_TICKET) {
      setModalOpened(null);
    } else {
      setModalOpened(TICKET_MODAL.UPDATE_TICKET);
    }
  };
  const handleBack = () => {
    if (typeof location.key !== 'undefined') history.goBack();
    else if (location.pathname.includes('company')) history.push(`/mycompanycases`);
    else history.push(`/mycases`);
  };

  return (
    <Page className={`tickets`} title="Tickets">
      <div className="container">
        <button className="btn-back" onClick={handleBack}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.93534 12.7715C5.45038 12.3715 5.45038 11.6285 5.93534 11.2285L13.8637 4.68933C14.516 4.15137 15.5 4.61532 15.5 5.46078L15.5 18.5392C15.5 19.3847 14.516 19.8486 13.8637 19.3107L5.93534 12.7715Z"
              fill="#234D96"
            />
          </svg>
          <span>{t('Tickets.back')}</span>
        </button>
        {ticketDetail && ticketDetail.incidentid === id ? (
          <>
            <h1 className="tickets-title">{ticketDetail.ticketnumber}</h1>
            <h2 className="tickets-sub-title">{t('Tickets.caseDetail')}</h2>
            <ProgressBar data={ticketDetail} />
            <div className="ticket-main">
              <TicketInfo data={ticketDetail} />
              <div className="ticket-right-side">
                <div className="ticket-shadow-box ticket-comments">
                  <p>
                    <strong>{t('Tickets.comments')}</strong>
                  </p>
                  <div className="comments-list">
                    {[...ticketDetail.comments]
                      .sort((a, b) => new Date(a.createdon) - new Date(b.createdon))
                      .map((data, index) => (
                        <Comment data={data} key={index} />
                      ))}
                  </div>
                  {ticketDetail.status !== TICKET_STATUS.closed && (
                    <div className="comment-btn">
                      <button onClick={() => toggleUpdateTicketModal(ticketDetail.incidentid)}>
                        <span>{t('Tickets.newComment')}</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <UpdateTicketModal
              incidentid={ticketDetail.incidentid}
              ticketnumber={ticketDetail.ticketnumber}
              open={modalOpened === TICKET_MODAL.UPDATE_TICKET}
              onClose={() => setModalOpened(null)}
            />
          </>
        ) : (
          <LoadingScreen />
        )}
      </div>
    </Page>
  );
}
